import React, { useRef } from 'react';

const BlogPage = ({ seminar, onSave, onSelectTitle }) => {
    const uploadInputRef = useRef(null);
    const photos = seminar.blogPhotos || [];
    const titleStyle = seminar.blogTitleStyle || {};

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newImagesPromises = files.map(file => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(file);
                });
            });

            Promise.all(newImagesPromises).then(newImageUrls => {
                const newPhotos = newImageUrls.map((url, index) => ({
                    id: Date.now() + index,
                    src: url,
                    liked: false,
                }));
                const updatedPhotos = [...photos, ...newPhotos];
                onSave({ ...seminar, blogPhotos: updatedPhotos });
            });
        }
    };
    
    const handleLike = (photoId) => {
        const updatedPhotos = photos.map(photo => 
            photo.id === photoId ? { ...photo, liked: !photo.liked } : photo
        );
        onSave({ ...seminar, blogPhotos: updatedPhotos });
    };

    return (
        <div className="h-full w-full bg-white relative">
            <div>
                <div
                    style={{
                        backgroundColor: titleStyle.backgroundColor || '#FFFFFF',
                        paddingTop: `${titleStyle.paddingTop || 16}px`,
                        paddingBottom: `${titleStyle.paddingBottom || 16}px`,
                    }}
                    onClick={onSelectTitle}
                    className="cursor-pointer"
                >
                    <h1
                        style={{
                            fontSize: `${titleStyle.fontSize || 24}px`,
                            fontWeight: titleStyle.fontWeight || 'bold',
                            textAlign: titleStyle.textAlign || 'left',
                            fontFamily: titleStyle.fontFamily || 'Lato',
                            color: titleStyle.color || '#000000',
                        }}
                        className="px-4"
                    >
                        {seminar.blogName || "Titre du Blog"}
                    </h1>
                </div>
                <div className="flex flex-col pb-16">
                     {photos.map((photo, index) => (
                        <div key={photo.id} className={`w-full bg-black relative ${index === photos.length - 1 ? '' : 'mb-2'}`}>
                            <img src={photo.src} alt={`Blog photo ${photo.id}`} className="w-full h-auto" />
                            <button onClick={() => handleLike(photo.id)} className="absolute bottom-2 right-2 text-white">
                                <svg className={`w-7 h-7 drop-shadow-lg ${photo.liked ? 'text-red-500' : 'text-white'}`} fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <button 
                onClick={() => uploadInputRef.current.click()}
                className="absolute bottom-[94px] left-1/2 -translate-x-1/2 bg-[#F2507B] text-white rounded-full p-4 shadow-lg hover:bg-opacity-90 z-20"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" /></svg>
            </button>
            <input 
                type="file" 
                ref={uploadInputRef}
                accept="image/*"
                multiple
                onChange={handleFileChange} 
                className="hidden" 
            />
        </div>
    );
};

export default BlogPage;